var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#41479B"
    },
    width: 170.67,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.67,
    style: {
      fill: "#FFE15A"
    },
    width: 170.67,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.33,
    style: {
      fill: "#FF4B55"
    },
    width: 170.67,
    height: 512
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCBE82"
    },
    d: "M316.023,284.644c0-2.562-2.077-4.639-4.639-4.639c-0.556,0-1.082,0.114-1.577,0.293  c-2.297-2.043-6.457-7.11-2.281-14.264c0.564,0.439,1.264,0.71,2.035,0.71c1.841,0,3.333-1.492,3.333-3.333  c0-1.454-0.937-2.678-2.236-3.133c3.431-1.75,8.325-5.465,8.072-12.411c-0.358-9.852-8.429-15.29-13.381-13.115  c0.018-0.138,0.042-0.274,0.042-0.416c0-1.815-1.471-3.286-3.286-3.286c-1.116,0-2.098,0.559-2.692,1.409  c-0.202-0.985-0.178-2.814,2.112-4.792c4.253-3.673,9.086-12.469,0.29-18.655c-4.871-3.426-14.182-5.066-17.301-0.387  c-1.353,2.03-0.268,4.945,1.276,5.6c-2.489,1.389-7.211,3.471-10.942,1.843c-5.316-2.32-2.246-6.926-1.063-8.989  c2.078-3.625,0.773-9.569-6.186-9.569c-4.639,0-6.959,4.639-11.599,4.639s-6.959-4.639-11.599-4.639  c-6.959,0-8.264,5.944-6.186,9.569c1.182,2.063,4.253,6.669-1.063,8.989c-3.731,1.628-8.452-0.454-10.942-1.843  c1.544-0.655,2.63-3.57,1.276-5.6c-3.119-4.679-12.43-3.039-17.301,0.387c-8.796,6.186-3.963,14.982,0.29,18.655  c2.29,1.977,2.314,3.806,2.112,4.792c-0.594-0.85-1.576-1.409-2.692-1.409c-1.815,0-3.286,1.471-3.286,3.286  c0,0.143,0.024,0.279,0.042,0.416c-4.952-2.175-13.022,3.264-13.381,13.115c-0.253,6.946,4.641,10.661,8.072,12.411  c-1.299,0.455-2.236,1.679-2.236,3.133c0,1.841,1.492,3.333,3.333,3.333c0.77,0,1.47-0.272,2.035-0.71  c4.176,7.155,0.015,12.222-2.281,14.264c-0.494-0.18-1.02-0.293-1.577-0.293c-2.562,0-4.639,2.077-4.639,4.639  c0,2.406,1.838,4.36,4.182,4.593c-3.198,3.284-6.067,10.525,0.168,18.749c6.814,8.989,23.052,8.264,30.881,8.554  c4.964,0.184,8.698,2.755,10.771,4.614c-1.325,0.817-2.217,2.269-2.217,3.94c0,2.343,1.743,4.261,4,4.575  c0.82,1.312,2.265,2.191,3.926,2.191c1.856,0,3.445-1.097,4.187-2.672c2.45,2.02,4.125,2.866,4.125,2.866s1.675-0.846,4.125-2.866  c0.742,1.575,2.331,2.672,4.187,2.672c1.661,0,3.106-0.879,3.926-2.191c2.257-0.314,4-2.232,4-4.575c0-1.671-0.891-3.123-2.217-3.94  c2.073-1.859,5.807-4.43,10.771-4.614c7.829-0.29,24.067,0.435,30.881-8.554c6.234-8.224,3.366-15.465,0.168-18.749  C314.185,289.005,316.023,287.05,316.023,284.644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2AA73"
    },
    d: "M214.245,225.056v67.272c0,7.687,6.231,13.918,13.918,13.918h18.558c6.959,0,9.279,4.639,9.279,4.639  s2.32-4.639,9.279-4.639h18.558c7.687,0,13.918-6.232,13.918-13.918v-67.272c0-1.281-1.039-2.32-2.32-2.32h-78.871  C215.283,222.736,214.245,223.775,214.245,225.056z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 218.88,
    y: 227.38,
    style: {
      fill: "#FF4B55"
    },
    width: 34.796,
    height: 34.796
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M253.68,301.607h-3.262c-17.416,0-31.534-14.118-31.534-31.534v-3.262h34.796L253.68,301.607   L253.68,301.607z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M261.582,301.607h-3.262v-34.796h34.796v3.262C293.116,287.489,278.998,301.607,261.582,301.607z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.32,
    y: 227.38,
    style: {
      fill: "#FFE15A"
    },
    width: 4.971,
    height: 34.796
  })), /*#__PURE__*/React.createElement("rect", {
    x: 263.29,
    y: 227.38,
    style: {
      fill: "#FF4B55"
    },
    width: 4.971,
    height: 34.796
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.26,
    y: 227.38,
    style: {
      fill: "#FFE15A"
    },
    width: 4.971,
    height: 34.796
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.23,
    y: 227.38,
    style: {
      fill: "#FF4B55"
    },
    width: 4.971,
    height: 34.796
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 278.2,
    y: 227.38,
    style: {
      fill: "#FFE15A"
    },
    width: 4.971,
    height: 34.796
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.14,
    y: 227.38,
    style: {
      fill: "#FFE15A"
    },
    width: 4.971,
    height: 34.796
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 283.17,
    y: 227.38,
    style: {
      fill: "#FF4B55"
    },
    width: 4.971,
    height: 34.796
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.48,
    y: 266.81,
    style: {
      fill: "#FF4B55"
    },
    width: 3.866,
    height: 34.796
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 234.35,
    y: 266.81,
    style: {
      fill: "#FFE15A"
    },
    width: 3.866,
    height: 34.796
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.08,
    y: 266.81,
    style: {
      fill: "#FFE15A"
    },
    width: 3.866,
    height: 34.796
  })), /*#__PURE__*/React.createElement("rect", {
    x: 238.22,
    y: 266.81,
    style: {
      fill: "#FF4B55"
    },
    width: 3.866,
    height: 34.796
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.81,
    y: 266.81,
    style: {
      fill: "#FFE15A"
    },
    width: 3.866,
    height: 34.796
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.95,
    y: 266.81,
    style: {
      fill: "#FF4B55"
    },
    width: 3.866,
    height: 34.796
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M222.751,299.837v-33.026h-3.866v25.517C218.884,295.426,220.417,298.152,222.751,299.837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M226.617,301.452v-34.64h-3.866v33.026C223.878,300.651,225.188,301.21,226.617,301.452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M226.617,266.811v34.64c0.505,0.085,1.017,0.156,1.547,0.156h2.32v-34.796H226.617z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M224.071,260.196c-0.173,0-0.348-0.048-0.503-0.152c-2.281-1.51-2.414-3.082-2.29-3.884   c0.167-1.083,0.974-1.983,2.053-2.292c1.028-0.289,2.053,0.014,2.747,0.819c1.439,1.674,2.927,2.333,4.179,1.87   c0.991-0.368,1.582-1.344,1.582-2.074c0-0.505,0.409-0.914,0.914-0.914s0.914,0.409,0.914,0.914c0,1.597-1.166,3.191-2.774,3.787   c-1.175,0.434-3.537,0.701-6.2-2.392c-0.286-0.33-0.623-0.319-0.859-0.253c-0.325,0.093-0.683,0.38-0.75,0.812   c-0.097,0.63,0.447,1.389,1.492,2.081c0.421,0.278,0.536,0.846,0.258,1.267C224.658,260.051,224.367,260.196,224.071,260.196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M248.604,260.196c-0.296,0-0.587-0.145-0.763-0.409c-0.278-0.421-0.163-0.989,0.258-1.267   c1.045-0.693,1.589-1.451,1.492-2.081c-0.067-0.432-0.425-0.719-0.75-0.812c-0.238-0.066-0.575-0.077-0.859,0.253   c-2.662,3.095-5.026,2.827-6.2,2.392c-1.607-0.596-2.774-2.19-2.774-3.787c0-0.505,0.409-0.914,0.914-0.914   s0.914,0.409,0.914,0.914c0,0.73,0.592,1.706,1.582,2.074c1.253,0.464,2.74-0.196,4.179-1.87c0.693-0.809,1.72-1.11,2.747-0.819   c1.08,0.309,1.887,1.208,2.053,2.292c0.124,0.801-0.009,2.374-2.29,3.884C248.952,260.146,248.777,260.196,248.604,260.196z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M223.567,261.281c-0.193,0-0.387-0.061-0.552-0.186c-0.402-0.307-0.479-0.88-0.174-1.281   l19.864-26.119c0.19-0.343,0.261-0.817,0.344-1.365c0.153-1.026,0.345-2.302,1.912-3.245c1.021-0.612,2.233-0.594,3.245,0.052   c1.117,0.714,1.777,2.044,1.641,3.309c-0.082,0.769-0.531,2.172-2.612,2.943c-0.476,0.177-0.999-0.068-1.174-0.539   c-0.176-0.473,0.066-0.999,0.539-1.174c0.607-0.225,1.348-0.655,1.431-1.424c0.062-0.584-0.27-1.23-0.808-1.574   c-0.302-0.193-0.774-0.357-1.319-0.025c-0.829,0.498-0.911,1.044-1.047,1.949c-0.096,0.641-0.205,1.367-0.634,2.106l-19.927,26.213   C224.116,261.156,223.843,261.281,223.567,261.281z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "236.408,232.553 227.27,243.519 230.925,254.485 241.891,254.485 245.546,243.519  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M236.408,231.125l-10.166,12.199l4.025,12.074h12.283l4.025-12.074L236.408,231.125z   M228.298,243.713l7.196-8.636v18.493h-3.91L228.298,243.713z M241.232,253.571h-3.91v-18.493l7.196,8.636L241.232,253.571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M284.562,277.797l0.138-2.028c0,0,1.797-1.29,0.922-2.488c-0.876-1.198-1.889-1.428-4.009-1.152  s-5.438,0.23-6.866,0.323c-1.429,0.092-2.166,0.876-4.424,0.23l0.599-1.382c0,0-1.06,0.092-1.705,0.415  c-0.352,0.176-1.198-0.968-2.028-0.783c-0.827,0.184-1.659,1.889-2.949,2.765l0.691,1.382c0,0,0.783-0.369,1.382,0.046  s0.783,0.691,1.797,0.691l0.645,0.276c0,0-0.23,1.475,0.737,2.166c0,0-1.106,1.428-0.968,1.659c0.138,0.23,1.06,1.981,1.428,2.995  l0.829-1.567c0,0-1.244-1.106-1.014-1.244s1.06-0.323,0.922-0.691s0.645,0.046,1.521,0.184c0,0,0.046,1.382,0.23,1.567  s0.461,0.922,0.415,1.705s-0.737,1.014-0.737,1.014l1.244,0.369c0,0,0.323-0.461,0.553-0.415c0,0-0.092-3.825,0.415-4.424  c0,0,2.995,0.599,4.378-0.138c0,0,0.177,0.223,0.522,0.435c-0.138,0.321-0.255,0.642-0.203,0.735  c0.116,0.208,0.486,0.185,0.578-0.046c0.035-0.087,0.089-0.266,0.144-0.451c0.167,0.055,0.35,0.098,0.559,0.119  c-0.019,0.291-0.022,0.559,0.045,0.622c0.175,0.161,0.519,0.024,0.535-0.225c0.005-0.081,0.002-0.234-0.002-0.398  c0.238-0.02,0.492-0.062,0.772-0.145l-1.567,2.581l-0.783,0.323l1.014,0.507l0.922-0.369c0,0,0.876-2.212,2.304-2.857  c0,0,0.968,2.304-0.23,3.548l1.06,0.599l0.507-1.06c0,0-0.184-2.074,0.507-3.41L284.562,277.797z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M267.208,271.212c0,0-0.463-0.439-0.578-1.018c-0.116-0.578-0.254-0.833-0.763-0.995   c0,0,0.324,0.37,0.278,0.948s0,1.365,0.324,1.619L267.208,271.212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M271.233,272.843c0,0-0.629,2.139-2.477,3.249l-0.645-0.276c0,0,1.972-1.686,2.212-3.133   L271.233,272.843z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M268.087,271.721c-0.066-0.069,0.81-0.324,0.601-1.018c-0.208-0.694-0.208-1.203,0.208-1.527   c0,0,0.046,0.578,0.37,0.948s0.509,1.295-0.023,1.827C269.244,271.952,268.712,272.369,268.087,271.721z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M268.188,278.027L268.188,278.027c-0.111-0.055-0.156-0.188-0.102-0.299l0.28-0.569   c0.164-0.333,0.055-0.747-0.266-0.932c-0.353-0.203-0.797-0.063-0.974,0.296l-0.29,0.59c-0.054,0.111-0.188,0.156-0.299,0.102   l-0.174,0.354c0,0,0.256,0.126,0.566,0.278l-0.006,0.013c-0.07,0.143-0.011,0.317,0.132,0.387c0.143,0.07,0.317,0.011,0.387-0.132   l0.006-0.013c0.31,0.153,0.566,0.278,0.566,0.278L268.188,278.027z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4173CD"
    },
    points: "270.424,281.922 271.117,282.06 270.539,283.842 269.954,282.912  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4173CD"
    },
    points: "272.12,283.88 271.696,284.628 273.361,284.628 273.364,284.249  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4173CD"
    },
    points: "280.322,283.327 280.322,283.772 278.432,283.772 279.347,282.858  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4173CD"
    },
    points: "283.318,283.65 282.384,284.583 284.348,284.583 284.377,284.249  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M284.562,292.236l0.138-2.028c0,0,1.797-1.29,0.922-2.488c-0.876-1.198-1.889-1.428-4.009-1.152  s-5.438,0.23-6.866,0.323c-1.429,0.092-2.166,0.876-4.424,0.23l0.599-1.382c0,0-1.06,0.092-1.705,0.415  c-0.352,0.176-1.198-0.968-2.028-0.783c-0.827,0.184-1.659,1.889-2.949,2.765l0.691,1.382c0,0,0.783-0.369,1.382,0.046  s0.783,0.691,1.797,0.691l0.645,0.276c0,0-0.23,1.475,0.737,2.166c0,0-1.106,1.428-0.968,1.659c0.138,0.23,1.06,1.981,1.428,2.995  l0.829-1.567c0,0-1.244-1.106-1.014-1.244s1.06-0.323,0.922-0.691s0.645,0.046,1.521,0.184c0,0,0.046,1.382,0.23,1.567  s0.461,0.922,0.415,1.705s-0.737,1.014-0.737,1.014l1.244,0.369c0,0,0.323-0.461,0.553-0.415c0,0-0.092-3.825,0.415-4.424  c0,0,2.995,0.599,4.378-0.138c0,0,0.177,0.223,0.522,0.435c-0.138,0.321-0.255,0.642-0.203,0.735  c0.116,0.208,0.486,0.185,0.578-0.046c0.035-0.087,0.089-0.266,0.144-0.451c0.167,0.055,0.35,0.098,0.559,0.119  c-0.019,0.291-0.022,0.559,0.045,0.622c0.175,0.161,0.519,0.024,0.535-0.225c0.005-0.081,0.002-0.234-0.002-0.398  c0.238-0.02,0.492-0.062,0.772-0.145l-1.567,2.581l-0.783,0.323l1.014,0.507l0.922-0.369c0,0,0.876-2.212,2.304-2.857  c0,0,0.968,2.304-0.23,3.548l1.06,0.599l0.507-1.06c0,0-0.184-2.074,0.507-3.41L284.562,292.236z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M267.208,285.651c0,0-0.463-0.439-0.578-1.018c-0.116-0.578-0.254-0.833-0.763-0.995   c0,0,0.324,0.37,0.278,0.948s0,1.365,0.324,1.619L267.208,285.651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M271.233,287.282c0,0-0.629,2.139-2.477,3.249l-0.645-0.276c0,0,1.972-1.686,2.212-3.133   L271.233,287.282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M268.087,286.16c-0.066-0.069,0.81-0.324,0.601-1.018c-0.208-0.694-0.208-1.203,0.208-1.527   c0,0,0.046,0.578,0.37,0.948s0.509,1.295-0.023,1.827C269.244,286.391,268.712,286.807,268.087,286.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M268.188,292.466L268.188,292.466c-0.111-0.055-0.156-0.188-0.102-0.299l0.28-0.569   c0.164-0.333,0.055-0.747-0.266-0.932c-0.353-0.203-0.797-0.063-0.974,0.296l-0.29,0.59c-0.054,0.111-0.188,0.156-0.299,0.102   l-0.174,0.354c0,0,0.256,0.126,0.566,0.278l-0.006,0.013c-0.07,0.143-0.011,0.317,0.132,0.387c0.143,0.07,0.317,0.011,0.387-0.132   l0.006-0.013c0.31,0.153,0.566,0.278,0.566,0.278L268.188,292.466z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4173CD"
    },
    points: "270.424,296.36 271.117,296.499 270.539,298.28 269.954,297.351  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4173CD"
    },
    points: "272.12,298.319 271.696,299.067 273.361,299.067 273.364,298.687  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4173CD"
    },
    points: "280.322,297.766 280.322,298.211 278.432,298.211 279.347,297.297  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4173CD"
    },
    points: "283.318,298.088 282.384,299.022 284.348,299.022 284.377,298.687  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAd);
export default __webpack_public_path__ + "static/media/ad.085e9fc415325c69451b4cdafafe944c.svg";
export { ForwardRef as ReactComponent };